import { Card, TextLink } from '@upside/flux-ui';

import { useTranslation } from 'react-i18next';

import { KRAKEN_SUPPORT_EMAIL } from '../../constants';

type ResetRequiredProps = {
  email: string;
  backToLogin: () => void;
};

export function ResetRequired({ email, backToLogin }: ResetRequiredProps) {
  const { t: translate } = useTranslation(['resetRequired', 'login']);

  return (
    <div className="my-auto flex w-full flex-col items-center gap-8">
      <Card className="relative flex w-full max-w-lg flex-col items-center gap-8 rounded-xl p-8 shadow-md">
        <h1 className="text-center text-2xl font-medium text-foreground">
          {translate('resetRequired:resetPassword')}
        </h1>
        <p className="text-center">
          {translate('resetRequired:resetPasswordDetails', {
            username: email,
          })}
        </p>
        <p className="text-center">
          {translate('resetRequired:contactDetails', {
            supportEmail: KRAKEN_SUPPORT_EMAIL,
          })}
        </p>
      </Card>

      <TextLink className="z-0" onClick={() => backToLogin()}>
        <TextLink.Label>
          {translate('resetRequired:backToLogin')}
        </TextLink.Label>
      </TextLink>
    </div>
  );
}
